import { render } from "./ThongKeDieuTriTrongThoiGian.vue?vue&type=template&id=59cba159&scoped=true&ts=true"
import script from "./ThongKeDieuTriTrongThoiGian.vue?vue&type=script&lang=ts"
export * from "./ThongKeDieuTriTrongThoiGian.vue?vue&type=script&lang=ts"

import "./ThongKeDieuTriTrongThoiGian.vue?vue&type=style&index=0&id=59cba159&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Dashboard_YHCT/Dashboard_FE_YHCT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cba159"]])

export default __exports__